import React from "react";
import {Layout} from "../layouts";
import FreeResourcesHero from "@/components/free-resources/free-resources-hero";
import SocialMediaMarketingGuide from "@/components/free-resources/social-media-marketing-guide";
import FreeResourcesSlider from "@/components/free-resources/free-resources-slider";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const FreeResources: React.FC = () => {
    return (
        <Layout page={"free-resources"}>
            <FreeResourcesHero/>
            <FreeResourcesSlider/>
            <SocialMediaMarketingGuide/>
        </Layout>
    )
}

export default FreeResources;
